<template>
  <div v-if="itemList && itemList.length > 0" class="goods-remark">
    <div class="goods-remark-title" @click="onToGoodsRemarkPage(good.id)">
      <div>基友秀</div>
      <div class="remark-all">全部 ></div>
    </div>
    <div class="item-list-container">
      <div class="remark-container" v-for="item in itemList" :key="item.id" @click="onDetail(item)">
        <div class="remark-box">
          <div class="cover-container">
            <img :src="item.cover_url"/>
          </div>
          <div class="description">
            {{item.description}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "MomentGoodsRemarkCell",
    props: {
      good: {}
    },
    data() {
      return {
        itemList: [],
      }
    },
    methods: {
      onDetail(item) {
        this.$router.push("/moment/" + item.id)
      },

      onToGoodsRemarkPage(goodsId) {
        this.$router.push("/goods_remark/" + goodsId)
      },

      onLoadRelatedItem() {
        if (!this.good || !this.good.item_attrs) {
          return
        }
        let relatedUgcItems = this.good.item_attrs.goods_remark
        if (!relatedUgcItems) {
          return;
        }
        let parsedObj = JSON.parse(relatedUgcItems)
        if (parsedObj && parsedObj.item_ids) {
          let itemIds = parsedObj.item_ids.split(',')
          let itemIdsInt = []
          for (let index = 0; index < itemIds.length; ++index) {
            itemIdsInt.push(parseInt(itemIds[index]))
          }
          this.$store.dispatch("GetUgcItemList", {ids: itemIdsInt}).then((data) => {
            if (data.code === 0 && data.data) {
              this.itemList = data.data
            }
          }, (err) => {
            console.log(err)
          })
        }
      },
    },
    watch: {
      good(newVal, oldVal) {
        if (this.good && this.good.id) {
          this.onLoadRelatedItem()
        }
      }
    }

  }
</script>

<style lang="scss" scoped>

  .goods-remark {
    color: rgba(0, 0, 0, 0.65);
    margin: 8px 0;
    background: white;
    padding: 10px 15px;
  }

  .item-list-container {
    padding: 5px 0;
    color: grey;
  }

  .goods-remark-title {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .remark-all {
      color: rgba(0, 0, 0, 0.45);
    }
  }


  .remark-container {
    position: relative;
    width: 100%;

    .remark-box {
      margin-top: 8px;
      display: flex;
    }

    .cover-container {
      width: 70px;
      height: 70px;
      border-radius: 4px;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
        -webkit-border-radius: 3px;
        -moz-border-radius: 3px;
        border-radius: 3px;
        object-fit: cover;
      }
    }

    .description {
      padding: 4px 14px;
      overflow: hidden;
      text-overflow: ellipsis;
      line-height: 20px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2; /* number of lines to show */

      p {
        font-size: 12px;
        color: #989797;
      }
    }
  }
</style>
